<template>
  <section>
    <div id="tabs">
      <div :class=isProfitTabActive @click="gameProfitView">
        <div>GAME EARNINGS</div>
      </div>
      <div :class=isSalaryTabActive @click="gamerSalaryView">
        <div>PLAYER SALARIES</div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  methods: {
    gameProfitView() {
      this.$store.commit("setView", { value: true });
    },
    gamerSalaryView() {
      this.$store.commit("setView", { value: false });
    },
  },
  computed: {
    isProfitTabActive() {
      if (this.$store.getters.isProfitViewActive) {
        return "tab-active";
      } else {
          return "tab";
      }
    },
    isSalaryTabActive() {
      if (!this.$store.getters.isProfitViewActive) {
        return "tab-active";
      } else {
          return "tab";
      }
    },
  },
};
</script>

<style lang="scss" scoped>
// section {
//   margin: 40px 0px 0px 0px;
// }

#tabs {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;

  font-family: Play-Bold;
  font-size: 14px;
  text-align: center;
}

.tab {
  margin: 0px 20px 0px 0px;
  border-radius: 30px;
  padding: 10px 40px 10px 40px;
  color: $white;
  border: 2px $orange1 solid;
  display:flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  &:hover{
    cursor:pointer;
     border: 2px $white solid;

  }
}

.tab-active {
  @extend .tab;
  background: linear-gradient($orange1, $orange2);
  color: $white;
  border:none;
  padding: 12px 42px 12px 42px;
  &:hover{
    cursor:pointer;
    border:none;
  }
}

</style>